import React, { Component } from 'react'
import styled from 'styled-components'
import { ICD10_MODAL } from '../lib/constants'
import { formatCode } from '../lib'
import { isAmwellTheme } from '../lib/util'
import greenOval from '../lib/assets/icons/green-oval.png'

const collapsedCount = 3

const DiagnosisItem = styled.div`
  position: relative;
  border-bottom: 1px solid #c6c6c8;
  padding: 25px 5px 25px 10px;
  color: #5f5f5f;
  line-height: 1.5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  &:hover {
    cursor: pointer;
    background: rgba(0,0,0,0.02)
  }
  .chevron-right {
    transform: scale(var(--ggs,1));
    width: 22px;
    height: 22px;
    border: 2px solid transparent;
    border-radius: 100px;
    padding-top: 3px;
  }

  .chevron-right::after {
    content: "";
    display: block;
    box-sizing: border-box;
    position: absolute;
    width: 14px;
    height: 14px;
    border-bottom: 2px solid rgba(60, 60, 68, 0.3);
    border-right: 2px solid rgba(60, 60, 68, 0.3);
    transform: rotate(-45deg);
    right: 6px;
  }
`

const DiagnosisItemDark = styled.div`
  position: relative;
  border-bottom: 1px solid #5b6b7b;
  padding: 25px 5px 25px 10px;
  color: #fff;
  line-height: 1.5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  transition: background 200ms ease-in 50ms;

  &:hover {
    cursor: pointer;
    background: rgba(0,0,0,0.2);
    transition: background 200ms ease-out 50ms;
  }

  .chevron-right-dark {
    transform: scale(var(--ggs,1));
    width: 22px;
    height: 22px;
    border: 2px solid transparent;
    border-radius: 100px;
    padding-top: 3px;
  }

  .chevron-right-dark::after {
    content: "";
    display: block;
    box-sizing: border-box;
    position: absolute;
    width: 14px;
    height: 14px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.3);
    border-right: 2px solid rgba(255, 255, 255, 0.3);
    transform: rotate(-45deg);
    right: 6px;
  }
`

const AquaOval = styled.li`
  position: absolute;
  right: 5px
  min-width: 20px;
  min-height: 20px;
  width: 10px;
  height: 10px;
  position: absolute;
  right: 5px;
  color: #00857a;
  top: 50%;
  transform: translate(-50%, -50%);
`

const GreenOval = styled.img.attrs({
  src: greenOval
})`
  width: 10px;
  height: 10px;
  position: absolute;
  right: 5px;

  top: 50%;
  transform: translate(-50%, -50%);
`

const ParentLabel = styled.div`
  background: #ececec;
  width: 100%;
  font-size: 21px;
  box-sizing: border-box;
  padding: 0 40px 10px;
`
const ParentLabelDark = styled.div`
  background: #313a42;
  width: 100%;
  font-size: 21px;
  box-sizing: border-box;
  margin-left: 13px;
`
const ICDCodeDark = styled.span`
  border-radius: 5px;
  border: 0;

  font-size: 0.8em;
  padding: 2px 5px;
  margin: 0 5px;

  background: ${props => (props.isChild ? '#5b6b7b' : '#00857a')};
  color: white;
  font-weight: ${props => (props.isChild ? '500' : '600')};
`
export const ICDCode = styled.span`
  border-radius: 5px;
  border: 0;

  font-size: 0.8em;
  padding: 2px 5px;
  margin: 0 5px;

  background: ${props => (props.isChild ? '#e4e4e4' : 'rgba(0, 0, 0, .075)')};
  color: ${props => (props.isChild ? '#a2a2a2' : '#406d70')};
  font-weight: ${props => (props.isChild ? '500' : '600')};
`

const DiagnosesList = styled.div`
  font-size: 16px;
  padding: 5px;

  h3 {
    margin: 0;
  }
  margin-bottom: 15px;
`

const ExpandLink = styled.button`
  font-weight: 600;
  color: #2e5f62;
  margin: 20px 0;
  border: 0;
  font-size: 14px;
  border-radius: 5px;
  padding: 5px 10px;
  float: right;
  &:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.05);
  }
`

class ICD10List extends Component {
  state = {
    isCollapsed: true,
    isAmwellDark: isAmwellTheme()
  }

  onItemClick = (e, diagnosisObj) => {
    const { children, diagnosis } = diagnosisObj
    const { setChild, setCode } = this.props
    if (children && children.length > 0) {
      setChild(diagnosisObj)
    } else {
      setCode(diagnosis)
    }
  }

  handleExpand = () => {
    this.setState({ isCollapsed: false })
  }

  getHighlightedText = (text, higlight) => {
    // should probably put this in util
    // Split on higlight term and include term into parts, ignore case
    higlight = higlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // escape/sanitize regex input
    const parts = text.split(new RegExp(`(${higlight})`, 'gi'))
    const { isAmwellDark } = this.state
    if (isAmwellDark) {
      return (
        <span>
          {parts.map((part, i) => (
            <span
              key={i}
              style={
                part.toLowerCase() === higlight.toLowerCase()
                  ? { fontWeight: 'bold', color: 'white' }
                  : {}
              }
            >
              {part}
            </span>
          ))}
        </span>
      )
    }
    return (
      <span>
        {parts.map((part, i) => (
          <span
            key={i}
            style={
              part.toLowerCase() === higlight.toLowerCase()
                ? { fontWeight: 'bold', color: 'black' }
                : {}
            }
          >
            {part}
          </span>
        ))}
      </span>
    )
  }

  formatCode = code => {
    if (code.length > 3) {
      return code.substring(0, 3) + '.' + code.substring(3)
    }
    return code
  }

  render () {
    const { diagnoses, type, parent, searchQuery } = this.props
    const { isCollapsed, isAmwellDark } = this.state

    const diagnosesList = diagnoses.map(diagnosisObj => {
      const { diagnosis, children } = diagnosisObj
      const { icdCode, description, problemLabel } = diagnosis
      if (isAmwellDark) {
        return (
          <DiagnosisItemDark
            key={icdCode}
            onClick={e => this.onItemClick(e, diagnosisObj)}
          >
            <div>
              {this.getHighlightedText(problemLabel || description, searchQuery)}
              <ICDCodeDark isChild={children && children.length > 0}>
                {formatCode(icdCode)}
              </ICDCodeDark>
            </div>
            {children && children.length > 0 ? (
              <div>
                <div className='chevron-right-dark' />
              </div>
            ) : (
              <AquaOval />
            )}
          </DiagnosisItemDark>
        )
      }
      return (
        <DiagnosisItem
          key={icdCode}
          onClick={e => this.onItemClick(e, diagnosisObj)}
        >
          <div>
            {this.getHighlightedText(problemLabel || description, searchQuery)}
            <ICDCode isChild={children && children.length > 0}>
              {formatCode(icdCode)}
            </ICDCode>
          </div>
          {children && children.length > 0 ? (
            <div>
              <div className='chevron-right' />
            </div>
          ) : (
            <div>
              <GreenOval />
            </div>
          )}
        </DiagnosisItem>
      )
    })

    // filtering top 3 for ML
    const showCollapsed =
      type === ICD10_MODAL.DIAGNOSTICS_ML &&
      isCollapsed &&
      diagnosesList.length > collapsedCount

    const displayedDiagnoses = showCollapsed
      ? diagnosesList.slice(0, collapsedCount)
      : diagnosesList

    if (isAmwellDark) {
      return (
        <>
          {parent && (
            <ParentLabelDark>
              {this.getHighlightedText(parent.problemLabel || parent.description, searchQuery)}
              <ICDCodeDark isChild>
                {formatCode(parent.icdCode)}
              </ICDCodeDark>
            </ParentLabelDark>
          )}

          <DiagnosesList>
            {!parent && <h3>{type}</h3>}
            {displayedDiagnoses}
            {showCollapsed && (
              <ExpandLink onClick={this.handleExpand}>
                {diagnosesList.length - collapsedCount} more
              </ExpandLink>
            )}
          </DiagnosesList>
        </>
      )
    }

    return (
      <>
        {parent && (
          <ParentLabel>
            {this.getHighlightedText(parent.problemLabel || parent.description, searchQuery)}
            <ICDCode isChild>
              {formatCode(parent.icdCode)}
            </ICDCode>
          </ParentLabel>
        )}

        <DiagnosesList>
          {!parent && <h3>{type}</h3>}
          {displayedDiagnoses}
          {showCollapsed && (
            <ExpandLink onClick={this.handleExpand}>
              {diagnosesList.length - collapsedCount} more
            </ExpandLink>
          )}
        </DiagnosesList>
      </>
    )
  }
}

export default ICD10List
